import * as React from 'react';
import { useStore } from 'react-redux';
import { ServiceCenter } from '../models/utilities/service-center';

export function useServiceCenter() : ServiceCenter {

    const store         = useStore();
    const [currentSC]   = React.useState(() => {
        return store.getState().userdata.activeServiceCenter;
    });

    return currentSC;
}
